import socketio from "socket.io-client";
import { createContext } from "react";

export const socketBackend = socketio.connect(
  "https://payments.trainity.live/"
);
export const socketAutomation = socketio.connect("https://cron.trainity.live/");
export const SocketContext = createContext();
